import getNLS from '../_NLS';

export default props=>{
    if (!props.me) return <></>;

const jsx = (<div className="TagItem">
    <style jsx>{`

.item{
    height: 54px;
    font-size: 14px;
    color: #343a40;

    padding: 8px 10px;
    text-align: left;
}

.item.highlight{
    background-color: #55d5ce;
    opacity: 0.1;
}

.dib{
    margin: 0 10px;
}

div.line{
    height: initial;
    line-height: initial;
}

.line{
    text-align: left;
}

.l1{
    text-align: left;
}

.l2{
    font-size: 10px;
    color: #868e96;
}

div.right{
    float:right;
    padding-top: 5px;
}

`}</style>
    <a href={"/hashtag?kw=" + (props.me.name && props.me.name.length>1 ? props.me.name.substring(1):"" )}>
<div className="item onhover">
    <div className="dib">
        <img src="/assets/images/hashtag.svg" />
    </div>
    <div className="dib">
        <div className="line l1">{props.me.name}</div>
        <div className="line l2">{props.me.posts_count} {getNLS("게시물")}</div>
    </div>
</div>
</a>
    
</div>);

    return (jsx);
};
